import { Theme } from '@radix-ui/themes'
import { PropsWithChildren } from 'react'

export const ThemeColor = 'blue' as const
export const ThemeProvider = (props: PropsWithChildren) => {
  return <Theme {...props} accentColor={ThemeColor} />
}
